import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl";
import "/src/tailwind.css";
import { resolveGraphQLEndpoint } from "./graphql-endpoint.js";

function escapeGraphQLString(value) {
  return String(value || "").replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\n/g, "\\n");
}

function getStoredAddressDetails(address, latitude, longitude) {
  try {
    const storedDetails = JSON.parse(sessionStorage.getItem("selectedAddressDetails") || "{}");
    if (storedDetails && storedDetails.address === address) {
      return storedDetails;
    }
  } catch {
    // Ignore malformed storage and fall back to individual keys.
  }

  return {
    address,
    street: sessionStorage.getItem("street") || "",
    houseNumber: sessionStorage.getItem("houseNumber") || "",
    postalCode: sessionStorage.getItem("postalCode") || "",
    municipality: sessionStorage.getItem("municipality") || "",
    latitude,
    longitude,
  };
}

function graphQLNullableStringField(name, value) {
  const normalizedValue = String(value || "").trim();
  return normalizedValue ? `${name}: "${escapeGraphQLString(normalizedValue)}"` : "";
}

document.addEventListener("DOMContentLoaded", function () {
  if (!sessionStorage.getItem("session_id")) {
    sessionStorage.setItem(
      "session_id",
      "session_" + Math.random().toString(36).substr(2, 9) + "_" + Date.now()
    );
  }

  let sessionId = sessionStorage.getItem("session_id");

  if (!sessionStorage.getItem("referrer")) {
    sessionStorage.setItem("referrer", document.referrer);
  }

  let trackingRef = sessionStorage.getItem("referrer") || "direct";
  const graphqlEndpoint = resolveGraphQLEndpoint();

  let mapLoaded = false;

  window.addEventListener("mousemove", loadMapbox, { once: true });
  window.addEventListener("touchstart", loadMapbox, { once: true });
  window.addEventListener("scroll", loadMapbox, { once: true });

  window.addEventListener("mousemove", loadResources, { once: true });
  window.addEventListener("touchstart", loadResources, { once: true });
  window.addEventListener("scroll", loadResources, { once: true });

  function loadMapbox() {
    if (mapLoaded) return;
    mapLoaded = true;
    initMap();
  }

  function loadResources() {
    const gtagScript1 = document.createElement("script");
    gtagScript1.src =
      "https://www.googletagmanager.com/gtag/js?id=G-E5LGRGZEZP";
    gtagScript1.async = true;
    document.body.appendChild(gtagScript1);

    const gtagScript2 = document.createElement("script");
    gtagScript2.src =
      "https://www.googletagmanager.com/gtag/js?id=AW-11171007225";
    gtagScript2.async = true;
    document.body.appendChild(gtagScript2);

    gtagScript1.onload = function () {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-E5LGRGZEZP");
    };

    gtagScript2.onload = function () {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11171007225");
    };

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 5010227, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

    // Controleer of de carousel-elementen bestaan
    const carousel = document.getElementById("carousel");
    const nextBtn = document.getElementById("nextBtn");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtnMobile = document.getElementById("nextBtnMobile");
    const prevBtnMobile = document.getElementById("prevBtnMobile");

   
    if (carousel) {
      let currentIndex = 0;
      const items = carousel.children;
      const totalItems = items.length;
      let autoScroll;
      let isAutoScrolling = true;
    
      function getVisibleItems() {
        if (window.innerWidth >= 1024) {
          return 3; // lg
        } else if (window.innerWidth >= 768) {
          return 2; // md
        } else {
          return 1; // mobiel
        }
      }
    
      function updateCarousel() {
        const visibleItems = getVisibleItems();
        const itemWidth = carousel.offsetWidth / visibleItems;
        const maxIndex = totalItems - visibleItems;
    
        // Zorg ervoor dat de currentIndex niet verder gaat dan de limieten
        if (currentIndex < 0) {
          currentIndex = 0; // Stop aan het begin
        }
        if (currentIndex > maxIndex) {
          currentIndex = maxIndex; // Stop aan het einde
        }
    
        const translateX = -currentIndex * itemWidth;
        carousel.style.transform = `translateX(${translateX}px)`;
      }
    
      function startAutoScroll() {
        autoScroll = setInterval(() => {
          const visibleItems = getVisibleItems();
          const maxIndex = totalItems - visibleItems;
    
          if (currentIndex < maxIndex) {
            currentIndex++;
            updateCarousel();
          } else {
            stopAutoScroll(); // Stop autoplay als het einde is bereikt
          }
        }, 5000);
      }
    
      function stopAutoScroll() {
        clearInterval(autoScroll);
        isAutoScrolling = false;
      }
    
      function handleInteraction() {
        if (isAutoScrolling) {
          stopAutoScroll();
        }
      }
    
      // Event listeners voor desktop knoppen
      if (nextBtn && prevBtn) {
        nextBtn.addEventListener("click", () => {
          const visibleItems = getVisibleItems();
          const maxIndex = totalItems - visibleItems;
    
          if (currentIndex < maxIndex) {
            currentIndex++;
            updateCarousel();
            handleInteraction();
          }
        });
    
        prevBtn.addEventListener("click", () => {
          if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
            handleInteraction();
          }
        });
      }
    
      // Event listeners voor mobiele knoppen
      if (nextBtnMobile && prevBtnMobile) {
        nextBtnMobile.addEventListener("click", () => {
          const visibleItems = getVisibleItems();
          const maxIndex = totalItems - visibleItems;
    
          if (currentIndex < maxIndex) {
            currentIndex++;
            updateCarousel();
            handleInteraction();
          }
        });
    
        prevBtnMobile.addEventListener("click", () => {
          if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
            handleInteraction();
          }
        });
      }
    
      // Stop autoplay bij touchinteractie
      carousel.addEventListener("touchstart", () => {
        handleInteraction();
      });
    
      // Update carousel bij venstergrootte verandering
      window.addEventListener("resize", () => {
        updateCarousel();
        handleInteraction();
      });
    
      // Initialiseer de carousel positie en start autoplay
      updateCarousel();
      startAutoScroll();
    }
    
    
    
    
  }

  function initMap() {
    mapboxgl.accessToken =
      "pk.eyJ1IjoibWFyY2gtZGV2IiwiYSI6ImNsMmh5aDF4MTBocHgzaXA5Ync1dHg1MmoifQ.5dZmY5XbqHX9QlF2K72obg";
    window.map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [4.399708, 51.219448],
      zoom: 7,
      scrollZoom: false,
    });

    map.on("load", function () {
      const placeholderImage = document.querySelector("#mapPlaceholder");
      if (placeholderImage) {
        placeholderImage.style.display = "none";
      }
    });

    map.on("click", function () {
      map.scrollZoom.enable();
    });

    map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: { enableHighAccuracy: true },
        trackUserLocation: true,
      })
    );

    map.addControl(new mapboxgl.NavigationControl());
  }

  document
    .getElementById("property-info-form")
    .addEventListener("submit", async function (event) {
      event.preventDefault();

      const chosenRadio = document.querySelector('input[name="userContext"]:checked');
      let errorEl = document.getElementById("userContext-error");
      if (!chosenRadio) {
        if (!errorEl) {
          errorEl = document.createElement('div');
          errorEl.id = "userContext-error";
          errorEl.className = 'text-red-500 text-sm mt-2';
          document.getElementById('userContext').appendChild(errorEl);
        }
        errorEl.style.display = 'block';
        errorEl.textContent = "Gelieve een optie te selecteren.";
        console.log('error user context');
        return; // Stop hier; formulier niet verzenden
      } else {
        // Verberg fout
        if (errorEl) {
          errorEl.style.display = 'none';
        }
      }

      function shouldAskSaleIntent(userContext) {
        return userContext === "OWNER" || userContext === "INHERITED_OR_MANAGING";
      }

      var adresValue = document.getElementById("adres").value;

      if (adresValue === "") {
        if (sessionStorage.getItem("selectedAddress") !== null) {
          adresValue = sessionStorage.getItem("selectedAddress");
        } else {
          adresValue = "";
        }
      }

      var latitude = document.getElementById("latitude").value;
      var longitude = document.getElementById("longitude").value;
      const selectedAddress = getStoredAddressDetails(adresValue, latitude, longitude);
      var buildableArea = document.getElementById("buildableArea").value;
      var bedroomCount = document.getElementById("bedroomCountNumber").value;
      var buildingCondition =
        document.getElementById("buildingCondition").value;
      var propertyType = document.getElementById("propertyType").value;
      var energyConsumptionPerSqm = document.getElementById(
        "energyConsumptionPerSqm"
      ).value;
      var surfacePlot = document.getElementById("surfacePlot").value;
      const isHouse = propertyType === "HOUSE";
      const surfacePlotField = isHouse ? `,
                        surfacePlot: ${surfacePlot}` : "";
      const allowedUserContexts = new Set(["OWNER", "INHERITED_OR_MANAGING", "BUYER", "CURIOUS"]);
      const userContext = chosenRadio ? chosenRadio.value : "";
      const hasValidUserContext = allowedUserContexts.has(userContext);
      const chosenSaleIntent = document.querySelector('input[name="saleIntent"]:checked');
      const allowedSaleIntents = new Set(["SELL_WITHIN_6_MONTHS", "MAYBE_LATER", "JUST_VALUE"]);
      const saleIntent = chosenSaleIntent ? chosenSaleIntent.value : "";
      const needsSaleIntent = shouldAskSaleIntent(userContext);
      const hasValidSaleIntent = allowedSaleIntents.has(saleIntent);

      if (hasValidUserContext) {
        sessionStorage.setItem("user_context", userContext);
      } else {
        sessionStorage.removeItem("user_context");
      }

      if (needsSaleIntent && hasValidSaleIntent) {
        sessionStorage.setItem("sale_intent", saleIntent);
      } else {
        sessionStorage.removeItem("sale_intent");
      }

      if (needsSaleIntent && !hasValidSaleIntent) {
        let saleIntentError = document.getElementById("saleIntent-error");
        if (!saleIntentError) {
          saleIntentError = document.createElement("div");
          saleIntentError.id = "saleIntent-error";
          saleIntentError.className = "text-red-500 text-sm mt-2";
          document.getElementById("saleIntentContainer").appendChild(saleIntentError);
        }
        saleIntentError.style.display = "block";
        saleIntentError.textContent = "Gelieve een optie te selecteren.";
        return;
      }

      sessionStorage.setItem(
        "prediction_id",
        "prediction_" +
          Math.random().toString(36).substr(2, 9) +
          "_" +
          Date.now()
      );
      let predictionId = sessionStorage.getItem("prediction_id");

      const query = `
                query {
                    predictPrice(predictionInput: {
                        sessionId: "${sessionId}",
                        predictionId: "${predictionId}",
                        platform: "${navigator.platform}",
                        userAgent: "${navigator.userAgent}",
                        screenWidth: ${parseInt(window.screen.width)},
                        trackingRef: "${trackingRef}",
                        address: "${escapeGraphQLString(selectedAddress.address)}",
                        ${graphQLNullableStringField("street", selectedAddress.street)},
                        ${graphQLNullableStringField("houseNumber", selectedAddress.houseNumber)},
                        ${graphQLNullableStringField("postalCode", selectedAddress.postalCode)},
                        ${graphQLNullableStringField("municipality", selectedAddress.municipality)},
                        latitude: ${latitude},
                        longitude: ${longitude},
                        buildableArea: ${buildableArea},
                        bedroomCount: ${bedroomCount},
                        buildingCondition: ${buildingCondition},
                        energyConsumptionPerSqm: ${energyConsumptionPerSqm},
                        propertyType: ${propertyType}${surfacePlotField}${hasValidUserContext ? `,
                        userContext: ${userContext}` : ""}${needsSaleIntent && hasValidSaleIntent ? `,
                        saleIntent: ${saleIntent}` : ""}
                    })
                }
            `;

      try {
        const response = await fetch(graphqlEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ query }),
        });

        const data = await response.json();
        var predictedPrice = parseInt(data.data.predictPrice);

        const predictionParams = {
          sessionId: sessionId,
          predictionId: predictionId,
          street: selectedAddress.street || "",
          houseNumber: selectedAddress.houseNumber || "",
          postalCode: selectedAddress.postalCode || "",
          municipality: selectedAddress.municipality || "",
          latitude: latitude,
          longitude: longitude,
          buildableArea: buildableArea,
          bedroomCount: bedroomCount,
          buildingCondition: buildingCondition,
          propertyType: propertyType,
          energyConsumptionPerSqm: energyConsumptionPerSqm,
          predictedPrice: predictedPrice,
        };
        if (isHouse) {
          predictionParams.surfacePlot = surfacePlot;
        }
        if (hasValidUserContext) {
          predictionParams.userContext = userContext;
        }
        if (needsSaleIntent && hasValidSaleIntent) {
          predictionParams.saleIntent = saleIntent;
        }

        var predictionUrl = "prediction?" + new URLSearchParams(predictionParams).toString();

        window.location.href = predictionUrl;
      } catch (error) {
        console.error("Fout bij het uitvoeren van de GraphQL-query:", error);
      }
    });
});
